module.exports = __webpack_public_path__ + "img/scanner.f207697b.svg";